<template>
  <v-layout column align-center v-scroll="searchMore">
    <v-col
      cols="12"
      md="9"
      lg="10"
      xl="10"
      sm="12"
      xs="2"
      xm="2"
      class="mt-8 ml-0"
    >
      <v-row :class="{ 'ml-n12': $vuetify.breakpoint.mdAndUp }">
        <span
          class="mb-7 text-right display-1 font-weight-bold grey--text text--darken-1"
        >
          {{ "Log de operações" }}</span
        >
      </v-row>

      <v-row justify="center">
        <v-progress-circular
          v-if="isLoading"
          :size="30"
          :width="4"
          color="blue darken-2"
          indeterminate
          class="ml-n2 mt-3 mb-n1 text-center"
        ></v-progress-circular>
      </v-row>

      <v-row>
        <v-data-table
          v-if="!loading"
          :headers="headers"
          :items="formatData()"
          class="elevation-2 ma-3 ml-5 mr-5"
          fixed-header
          no-data-text="Nenhuma operação de log encontrada"
          height="65vh"
          style="width: 100vw"
        >
        </v-data-table>
      </v-row>
    </v-col>
  </v-layout>
</template>

<script>
export default {
  components: {},
  methods: {
    formatData() {
      if (!this.operations || this.operations.length === 0) {
        return;
      }

      return this.operations.map((operation) => {
        return {
          username: operation.username,
          actionType: operation.actionType,
          createdOn:
            this.$formatDate(operation.createdOn.date) +
            " " +
            operation.createdOn.time,
          entityIdentification: operation.entityIdentification,
          entityContract: operation.entityContract,
          entityServiceLine: operation.entityServiceLine,
          resultStatus: operation.resultStatus,
          message: operation.message || "N/A",
        };
      });
    },
  },
  data: () => ({
    operations: [],
    isLoading: false,
    headers: [
      {
        text: "Usuário",
        align: "center",
        sortable: false,
        value: "username",
      },
      {
        text: "Identificador da entidade",
        align: "center",
        sortable: false,
        value: "entityIdentification",
      },
      {
        text: "Tipo de ação",
        align: "center",
        sortable: false,
        value: "actionType",
      },
      {
        text: "Mensagem",
        align: "center",
        sortable: false,
        value: "message",
      },
      {
        text: "Data",
        align: "center",
        sortable: false,
        value: "createdOn",
      },
      {
        text: "Contrato",
        align: "center",
        sortable: false,
        value: "entityContract",
      },
      {
        text: "Linha de serviço",
        align: "center",
        sortable: false,
        value: "entityServiceLine",
      },
      {
        text: "Status",
        align: "center",
        sortable: false,
        value: "resultStatus",
      },
    ],
  }),
  created: function () {
    this.isLoading = true;
    this.$get("/operation-log/busca").then((response) => {
      this.operations = response.data;
      this.isLoading = false;
    });
  },
};
</script>
